import React from 'react';
import { Timer as TimerIcon } from 'lucide-react';

// Таймер для КЛИНИЧЕСКИХ шкал: цифры и тонкая полоса, без анимаций и
// поощрений. Тренажёр использует тот же useTimerState, но рисует его
// Lottie-кольцом (exercises-engine/ui/ProgressRing.jsx) — разделение
// движков проходит именно по UI, арифметика времени общая.
export default function ClinicalTimer({ remainingSec, percent, warnAtSec = 10, label = 'Осталось' }) {
  const isWarning = remainingSec <= warnAtSec;
  const mm = Math.floor(Math.max(0, remainingSec) / 60);
  const ss = Math.max(0, remainingSec) % 60;

  return (
    <div className="flex items-center gap-3 rounded-2xl border border-border bg-secondary/70 px-4 py-2 backdrop-blur-sm">
      <TimerIcon className={`size-4 ${isWarning ? 'text-red-500' : 'text-muted-foreground'}`} />
      <div className="flex flex-col gap-1">
        <div className="flex items-baseline gap-2">
          <span className="text-[11px] uppercase tracking-wide text-muted-foreground">{label}</span>
          <span className={`font-mono text-xl font-bold tabular-nums ${isWarning ? 'text-red-500' : 'text-primary'}`}>
            {mm}:{String(ss).padStart(2, '0')}
          </span>
        </div>
        <div className="h-1.5 w-40 overflow-hidden rounded-full bg-border">
          <div
            className={`h-full rounded-full transition-[width] duration-200 ease-linear ${isWarning ? 'bg-red-500' : 'bg-accent'}`}
            style={{ width: `${100 - Math.min(100, Math.max(0, percent))}%` }}
          />
        </div>
      </div>
    </div>
  );
}
